import {useEffect, useState} from 'react'
import {Link, useSearchParams} from 'react-router-dom'
import {updatePass, validateResetToken} from '../core/_requests'
import {PasswordSecurityFields, validatePasswordFields} from '../../../components/ChangePasswordForm/ChangePasswordForm'
import {useAuth} from '../core/Auth'
import './PasswordRecovery.css'

export function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [state, setState] = useState('loading')
  const [error, setError] = useState('')
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [saving, setSaving] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  useEffect(() => {
    let cancelled = false
    setState('loading')
    setError('')
    setPassword('')
    setConfirmation('')
    if (!token) {
      setState('invalid')
      setError('El enlace para restablecer tu contraseña no es válido.')
      return
    }
    validateResetToken(token).then(() => {
      if (!cancelled) setState('valid')
    }).catch((e) => {
      if (!cancelled) {
        setState('invalid')
        setError(e.response?.data?.message || 'No fue posible validar el enlace. Inténtalo nuevamente.')
      }
    })
    return () => { cancelled = true }
  }, [token])

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (saving || state !== 'valid') return
    const validation = validatePasswordFields(password, confirmation)
    if (validation) { setError(validation); return }
    setSaving(true)
    setError('')
    try {
      await updatePass(token, password, confirmation)
      setPassword('')
      setConfirmation('')
      saveAuth(undefined)
      setCurrentUser(undefined)
      setState('success')
    } catch (e: any) {
      setError(e.response?.data?.message || 'No fue posible actualizar la contraseña. Inténtalo nuevamente.')
      if (['invalid_token', 'expired_token', 'used_token'].includes(e.response?.data?.code)) setState('invalid')
    } finally { setSaving(false) }
  }

  return <div className='password-recovery'>
    <div className='text-center mb-10'><h1 className='text-dark mb-3'>Restablecer contraseña</h1></div>
    {state === 'loading' && <p role='status'>Validando enlace...</p>}
    {state === 'success' ? <>
      <div className='alert alert-success' role='status'>Tu contraseña se actualizó correctamente.</div>
      <Link to='/auth' className='btn btn-lg btn-primary w-100'>Iniciar sesión</Link>
    </> : <>
      {state === 'valid' && <form className='form w-100' onSubmit={submit} noValidate>
        <fieldset disabled={saving} className='recovery-fields'>
          <PasswordSecurityFields newPassword={password} confirmPassword={confirmation} onNewPasswordChange={setPassword} onConfirmPasswordChange={setConfirmation} inputClassName='form-control form-control-lg form-control-solid' />
        </fieldset>
        {error && <div className='alert alert-danger' role='alert'>{error}</div>}
        <button type='submit' className='btn btn-lg btn-primary w-100 mt-5 mb-5' disabled={saving}>{saving ? 'Guardando...' : 'Actualizar contraseña'}</button>
      </form>}
      {state === 'invalid' && <>
        <div className='alert alert-danger' role='alert'>{error}</div>
        <Link to='/auth/forgot-password' className='btn btn-lg btn-primary w-100 mb-5'>Solicitar un nuevo enlace</Link>
      </>}
      <div className='text-center mt-5'><Link to='/auth' className='link-primary fw-bolder'>Volver a iniciar sesión</Link></div>
    </>}
  </div>
}
